import Box from '@mui/material/Box';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { PATHS } from '../../config/consts';
import ButtonLink from '../ButtonLink';
import messages from './messages';

const Footer = ({ companyId }) => (
  <Box sx={{ p: 2 }}>
    <ButtonLink
      color="primary"
      data-testid="company-dashboard-sites-link"
      id="sites-link"
      size="small"
      to={PATHS.COMPANY_SITES.replace(':companyId', companyId)}
    >
      <FormattedMessage {...messages.footerViewAllSites} />
    </ButtonLink>
  </Box>
);

Footer.propTypes = {
  companyId: PropTypes.number.isRequired,
};

export default Footer;
